module.exports = __webpack_public_path__ + "img/Recommend_kklb.5ab17b18.png";